<template>
  <div class="product">
    <com-returntop></com-returntop>
    <img
      class="product-banner"
      src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/product/banner.png"
      alt
    />
    <div class="product-title">
      <h1>Simulation Products</h1>
      <p>仿真产品</p>
    </div>
    <div class="product-menu">
      <ul>
        <li
          v-for="(item, index) in menuList"
          :key="index"
          :class="
            activeName == index
              ? 'product-menu-active'
              : 'product-menu-noactive'
          "
          @click="menuClick(index)"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
    <div class="product-list">
      <div
        class="product-list-box"
        v-for="(item, index) in dataList"
        :key="index"
      >
        <div class="product-list-text" v-if="index % 2 == 0">
          <h1>{{ item[0].category.name }}</h1>
          <div></div>
          <p>
            <span
              v-for="(child, cid) in item"
              :key="cid"
              @click="
                toDetail(child.id, child.category_id, item[0].category.name)
              "
            >
              <span v-show="cid != 0">、</span>
              {{ child.name }}
            </span>
          </p>
        </div>
        <div class="product-list-img">
          <img :src="item[0].img" alt />
        </div>
        <div class="product-list-text" v-if="index % 2 != 0">
          <h1>{{ item[0].category.name }}</h1>
          <div></div>
          <p>
            <span
              v-for="(child, cid) in item"
              :key="cid"
              @click="
                toDetail(child.id, child.category_id, item[0].category.name)
              "
            >
              <span v-show="cid != 0">、</span>
              {{ child.name }}
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import comReturntop from "@/components/returntop";
import { Article, ArChildren } from "./../services/article";
import { setTimeout } from "timers";
export default {
  components: {
    comReturntop,
  },
  data() {
    return {
      activeName: 0,
      menuList: [
        {
          name: "新能源仿真",
          id: "153",
        },
        {
          name: "电力仿真",
          id: "82",
        },
        {
          name: "环保仿真",
          id: "166",
        },
        {
          name: "建材仿真",
          id: "83",
        },
        {
          name: "化工技术",
          id: "172",
        },
        {
          name: "课程资源",
          id: "174",
        },
        {
          name: "虚拟实验",
          id: "85",
        },
        {
          name: "建模软件",
          id: "181",
        },
      ],
      dataList: [
        [
          {
            category_id: 0,
            id: 0,
            name: "",
            category: {
              name: "",
            },
          },
        ],
      ],
      cList: [
        {
          id: "153",
          cid: ["154", "155", "156", "157", "158", "159", "160"],
        },
        {
          id: "82",
          cid: ["161", "162", "163", "164", "165"],
        },
        {
          id: "166",
          cid: ["167", "168", "169", "170", "171"],
        },
        {
          id: "83",
          cid: ["100", "101", "102", "103", "104", "106", "107"],
        },
        {
          id: "172",
          cid: ["173"],
        },
        {
          id: "174",
          cid: ["176", "177", "178", "179", "183"],
        },
        {
          id: "85",
          cid: ["180"],
        },
        {
          id: "181",
          cid: ["182"],
        },
      ],
      isFetching: false,
    };
  },

  created() {},
  mounted() {
    let that = this;
    let clickId = that.$route.query.id;
    if (!clickId) {
      that.menuClick(0);
    } else {
      that.menuClick(clickId);
    }
  },
  watch: {
    // $route: {
    //   handler() {
    //     if ((this.id == this.$route.query.id)) {
    //       var i = this.id;
    //       this.menuClick(i);
    //     }
    //     //深度监听，同时也可监听到param参数变化
    //   },
    //   deep: true,
    // },
  },
  methods: {
    menuClick(index) {
      //根据设置动态路由，展示不同页面
      this.$router.push({
        path: "/product",
        query: {
          id: index,
        },
      });
      this.activeName = index;
      this.dataList = [];
      let id = this.cList[index].id;
      // 查询二级菜单下的子项
      ArChildren({
        pid: id,
      }).then((res1) => {

        // 后台返回的子项列表
        let imgList = res1.items;

        // 根据子项的id，查询子项的封面图
        this.cList[index].cid.forEach((item) => {
          //java后台管理系统，补充前端需要的category对象
          let category = {};
          category.id = item;
          // 遍历后台返回的子项列表，将name赋值给category
          imgList.forEach((citem) => {
            if (citem.id == item) {
              category.name = citem.name;
            }
          });
          //end

          // 查询子项下的文章
          Article({
            category_id: item,
          }).then((res2) => {
            if (res2.items.length > 0) {
              //将封面图的地址替换到子项中
              imgList.forEach((citem) => {
                if (citem.id == res2.items[0].category_id) {
                  res2.items[0].img = citem.image;
                }
              });
              //适配java后台管理系统，增加category对象
              res2.items.forEach((e) => {
                e.category = category;
              });
              //end
              this.dataList.push(res2.items);
            }
            this.dataList.sort((a, b) => {
              return a[0].category_id - b[0].category_id;
            });
          });
        });
      });
    },
    // 跳转至详情页
    toDetail(id, fid, name) {
      let titleList = [
        "首页",
        "仿真产品",
        this.menuList[this.activeName].name,
        name,
      ];
      this.$router.push({
        name: "solutionActive",
        query: {
          id: id,
          type: fid,
          titleList: titleList,
        },
      });
    },
  },
};
</script>
<style scoped>
.product {
  position: relative;
  background: #eee;
  padding-bottom: 80px;
}

.product-banner {
  width: 100%;
  height: 450px;
}

.product-title {
  position: absolute;
  top: 208px;
  width: 100%;
  text-align: center;
  color: #fff;
}

.product-title h1 {
  font-size: 50px;
}

.product-title p {
  font-size: 24px;
  margin-top: 10px;
}

.product-menu {
  width: 1200px;
  background: #fff;
  position: absolute;
  top: 410px;
  height: 80px;
  left: 50%;
  margin-left: -600px;
}

.product-menu ul {
  display: flex;
  width: 1200px;
  margin: 0 auto;
}

.product-menu li {
  width: 150px;
  cursor: pointer;
  height: 80px;
  font-size: 16px;
  text-align: center;
  line-height: 80px;
}

.product-menu .product-menu-active {
  background: #0a57f4;
  color: #fff;
}

.product-menu .product-menu-noactive {
  background: #fff;
  color: #333;
}

.product-list {
  padding-top: 100px;
  width: 1200px;
  margin: 0 auto;
}

.product-list-box {
  display: flex;
}

.product-list-img {
  position: relative;
  width: 600px;
  height: 294px;
}

.product-list-img img {
  width: 600px;
  height: 294px;
  cursor: pointer;
  transition: all ease 0.8s;
}

.product-list-img img:hover {
  transform: scale(1.03);
}

.product-list-text {
  width: 520px;
  height: 305px;
  padding: 0 40px;
  background: #e3e3e3;
  color: #333;
}

.product-list-text h1 {
  font-size: 34px;
  margin-top: 20px;
}

.product-list-text div {
  margin-top: 27px;
  margin-bottom: 30px;
  width: 36px;
  height: 3px;
  background: #0055d3;
}

.product-list-text p {
  font-size: 16px;
  line-height: 28px;
}

.product-list-text span {
  cursor: pointer;
}

.product-list-text span:hover {
  color: #0055d3;
}
</style>
